import { 
  Container, 
  Typography, 
  Box,
  Paper
} from '@mui/material';
import Hero from '../components/common/Hero';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';

const Photos = () => {
  return (
    <>
      <Helmet>
        <title>Photo Gallery | Brynleigh Estates HOA</title>
        <meta name="description" content="Browse photos of our beautiful Brynleigh Estates community in Chelsea, Alabama. View community events, neighborhood scenes, and more." />
        <link rel="canonical" href="https://brynleighestates.com/photos" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://brynleighestates.com/photos" />
        <meta property="og:title" content="Photo Gallery | Brynleigh Estates HOA" />
        <meta property="og:description" content="Browse photos of our beautiful Brynleigh Estates community in Chelsea, Alabama. View community events, neighborhood scenes, and more." />
        <meta property="og:image" content="https://brynleighestates.com/images/brynleigh-estates-social-logo.jpeg" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Photo Gallery | Brynleigh Estates HOA" />
        <meta name="twitter:description" content="Browse photos of our beautiful Brynleigh Estates community in Chelsea, Alabama." />
        <meta name="twitter:image" content="https://brynleighestates.com/images/brynleigh-estates-social-logo.jpeg" />
      </Helmet>
      
      <Hero 
        imageUrl="/images/hills-bg.jpeg"
        title="Photo Gallery"
        subtitle="Capturing our community moments"
      />
      
      <Container maxWidth="lg">
        <Box sx={{ my: 6 }}>
          <Typography variant="h4" gutterBottom fontWeight="medium" component="h1" align="center">
            Brynleigh Estates Gallery
          </Typography>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Paper 
              elevation={3} 
              sx={{ 
                p: 6, 
                mt: 4, 
                textAlign: 'center',
                borderRadius: 2,
                backgroundColor: 'rgba(245, 245, 245, 0.9)'
              }}
            >
              <Typography variant="h2" component="div" gutterBottom sx={{ fontWeight: 'bold' }}>
                Coming Soon
              </Typography>
              <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
                Our photo gallery is currently under construction.
              </Typography>
              <Typography variant="body1" paragraph>
                We're working on collecting and organizing beautiful photos of our community.
                Check back soon to see images of community events, neighborhood views, and more!
              </Typography>
            </Paper>
          </motion.div>
          
          <Box sx={{ mt: 6, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom>
              Share Your Photos With Us
            </Typography>
            <Typography variant="body1">
              Have great photos of our community you'd like to share? 
              Email them to <strong>hoa@brynleighestates.com</strong> and we may feature them in our gallery!
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Photos; 